var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMoveFolder = function SvgIconMoveFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 7.62v11.546a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h3.596a1 1 0 0 1 .67.257L9.85 5.85a3 3 0 0 0 2.007.77H20a1 1 0 0 1 1 1M2 19.167v-14a2 2 0 0 1 2-2h3.596a2 2 0 0 1 1.338.513l1.587 1.428a2 2 0 0 0 1.337.514H20a2 2 0 0 1 2 2v11.545a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2m6-6.467a.5.5 0 0 0 0 1h6.97l-1.848 2.14a.5.5 0 1 0 .756.654l2.516-2.911.005-.007a.6.6 0 0 0 0-.753l-2.517-2.979a.5.5 0 0 0-.764.646l1.868 2.21z",
    clipRule: "evenodd"
  })));
};
export default SvgIconMoveFolder;